import Projectsec1 from "../../components/Projects/projectsec1";

const Project = () => {
    return(
        <Projectsec1/>
    );
};

export default Project;